export function postMessageToParent(message: string) {
  if (window.parent === window) return
  window.parent.postMessage(message, '*')
}
